module.exports = __webpack_public_path__ + "img/148.25305d0a.jpg";